"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getHtmlDocument = function getHtmlDocument(html) {
  return new DOMParser().parseFromString(html, 'text/html');
};
var _default = exports["default"] = getHtmlDocument;